import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import { createBEM } from '../../../lib/utils/css';

import './ActionRow.scss';

class ActionRow extends React.Component {
  static propTypes = {
    onClick: PropTypes.function,
    mainText: PropTypes.node,
    secondText: PropTypes.string,
    url: PropTypes.string,
    hasBottomBorder: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
  };

  generateClasses() {
    return createBEM('ActionRow', {
      hasBottomBorder: this.props.hasBottomBorder,
      isMobile: this.props.isMobileDevice,
    });
  }

  renderLink() {
    const { url, mainText, secondText, onClick } = this.props;

    const mainTextClasses = createBEM('ActionRow__mainText', {
      isMobile: this.props.isMobileDevice,
    });

    const secondTextClasses = createBEM('ActionRow__secondText', {
      isMobile: this.props.isMobileDevice,
    });

    return (
      <Link to={url} className={this.generateClasses()} onClick={onClick}>
        <div className={mainTextClasses}>{mainText}</div>
        {secondText && <div className={secondTextClasses}>{secondText}</div>}
      </Link>
    );
  }

  renderButton() {
    const { onClick, mainText } = this.props;

    return (
      <button type='button' className={this.generateClasses()} onClick={onClick}>
        {mainText}
      </button>
    );
  }

  render() {
    if (this.props.url) return this.renderLink();
    return this.renderButton();
  }
}

export default ActionRow;
